import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGuidelines = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#A5A5AA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.236 3.417c.65-.556 1.714-.556 2.373 0l1.488 1.28c.283.245.81.443 1.187.443h1.6c.999 0 1.818.82 1.818 1.818v1.6c0 .368.198.905.443 1.187l1.28 1.488c.556.65.556 1.714 0 2.374l-1.28 1.488c-.245.282-.443.81-.443 1.186v1.601c0 .999-.82 1.818-1.817 1.818h-1.601c-.368 0-.904.198-1.187.442l-1.488 1.281c-.65.556-1.714.556-2.373 0l-1.488-1.28c-.283-.245-.81-.443-1.187-.443h-1.63c-.997 0-1.817-.82-1.817-1.818v-1.61c0-.367-.197-.895-.433-1.177L3.41 13.597c-.547-.65-.547-1.704 0-2.354l1.27-1.498c.236-.282.433-.81.433-1.177v-1.61c0-.998.82-1.818 1.818-1.818h1.63c.366 0 .903-.198 1.186-.442l1.488-1.281Z"
    />
    <path
      stroke="#A5A5AA"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m10.426 15.066 1.365 1.055c.18.18.575.264.839.264h1.666c.528 0 1.102-.396 1.234-.923l1.055-3.22c.217-.613-.179-1.15-.838-1.15h-1.761c-.264 0-.48-.216-.443-.527l.217-1.413c.084-.395-.18-.838-.575-.97-.348-.132-.79.047-.97.31l-1.808 2.685"
    />
    <path
      stroke="#A5A5AA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.175 15.066v-4.313c0-.621.264-.838.885-.838h.443c.612 0 .885.217.885.838v4.313c0 .612-.264.838-.885.838H9.06c-.621 0-.885-.216-.885-.838Z"
    />
  </svg>
);
export default SvgGuidelines;
